import React from 'react';
import { Field } from 'redux-form';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem'


/*
<FormControl className={classes.formControl}>
                    <InputLabel htmlFor="parent-select">父菜单名称</InputLabel>
                    <Select
                        value={module.parentId}
                        onChange={(e) => dispatch({type: actions.CHANGE_SETTING,key: 'parentId',value: e.target.value})}
                        input={<Input name="age" id="age-simple" />}
                        required
                    >
                        {list.filter((item,index) => {
                                if (!item.parentName && !item.parentId) {
                                    return true
                                }}).map((i,index) => {
                                        return (
                                            <MenuItem key={index} value={i.id}>{i.name}</MenuItem>
                                        )
                        })}
                    </Select>
                </FormControl>
*/
const renderTextField = ({input, label, placeholder, type, className, style, children, disabled, required = false, meta: { touched, error }, readOnly = false, data = []}) => (
    <TextField
        {...input}
        select
        label={`${label ? label : ''}${touched && error ? error : ''}`}
        error={touched && error}
        className={className}
        style={style}
        margin="normal"
        required={required}
        disabled={disabled}
        InputProps={{
            readOnly: readOnly,
        }}
    >
        {data.map((item,index) => {
            return <MenuItem value={item.value} key={index}>{item.name}</MenuItem>
        })}
    </TextField>
)
export default (obj) => {
    return <Field component={renderTextField} {...obj} />
}


// WEBPACK FOOTER //
// ./src/uis/form/select.js